import valueFilters from '../valueFilters';

export interface IVisitable {
	requiresDelivery: boolean;
	requiresInstall: boolean;
}

const visitable = {
	requiresDelivery: {
		defaultValue: true,
		setFilters: valueFilters.toBoolean
	},
	requiresInstall: {
		defaultValue: true,
		setFilters: valueFilters.toBoolean
	}
};

export default visitable;